import { useRef, useEffect } from "react";
import { SketchPicker } from "react-color";

function ColorPickerField({
  settings,
  index,
  showIndex,
  setShowIndex,
  handleSetColor,
}) {
  const pickerRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        setShowIndex(null);
      }
    }

    if (showIndex === index) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showIndex, index, setShowIndex]);

  return (
    <div className="field" key={index}>
      <label>{settings.lable}</label>
      <div
        className="form-select"
        style={{ backgroundColor: settings.color }}
        onClick={() => setShowIndex(index)}
      />
      {showIndex === index && (
        <div className="choose-color_style" ref={pickerRef}>
          <img
            alt="close"
            src="/images/icons/modal-close-icon14x14.png"
            className="choose-color_style_modal"
            onClick={() => setShowIndex(null)}
          />
          <SketchPicker
            color={settings?.color}
            onChange={(value) => handleSetColor(value.rgb, settings.key)}
          />
        </div>
      )}
    </div>
  );
}

export default ColorPickerField;
